var map = {
	"./banner_shopee.svg": 72,
	"./g_Vector.svg": 73,
	"./havecard-1.svg": 74,
	"./havecard-2.svg": 75,
	"./havecard-3.svg": 76,
	"./havecard-4.svg": 77,
	"./icon-facebook.svg": 25,
	"./icon-instagram.svg": 26,
	"./icon-linkedin.svg": 27,
	"./jakarta-gray.svg": 78,
	"./jakarta.svg": 79,
	"./kualaLumpur-gray.svg": 80,
	"./kualaLumpur.svg": 81,
	"./left_empty_triangle.svg": 9,
	"./left_triangle.svg": 82,
	"./manila-gray.svg": 83,
	"./manila.svg": 84,
	"./shenzhen-gray.svg": 85,
	"./shenzhen.svg": 86,
	"./shopee_white.svg": 87,
	"./singapore-gray.svg": 88,
	"./singapore.svg": 89,
	"./taiwan-gray.svg": 90,
	"./taiwan.svg": 91,
	"./teams-dev-commer.svg": 92,
	"./teams-intelligence.svg": 93,
	"./teams-marketing.svg": 94,
	"./teams-operations.svg": 95,
	"./thailand-gray.svg": 96,
	"./thailand.svg": 97,
	"./them_arrow.svg": 10,
	"./triangle_1.png": 98,
	"./two_red_triangle.svg": 18,
	"./two_session_triangle.svg": 21,
	"./two_triangle_xie.svg": 19,
	"./vietnam-gray.svg": 99,
	"./vietnam.svg": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;